<!--
 * @Author: 孙泽严 343362726@qq.com
 * @Date: 2022-05-12 11:25:50
 * @LastEditors: 孙泽严 343362726@qq.com
 * @LastEditTime: 2022-05-12 14:02:22
 * @FilePath: \admin_kakaclo_front_end\src\views\operation\newFunction\add\components\languageSelect.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <span v-for="country in countrys" :key="country.code" :class="['country-item', 'ellipsis', {active: active === country.code}]" @click="() => handleCountryItem(country)">{{country.name}}</span>
  </div>
</template>

<script>

import API from '@/api'

export default {
  props: {
    active: {
      type: Number,
      default: () => 1
    }
  },
  data() {
    return {
      countrys: [] // 左侧语言列表数据
    }
  },
  created() {
    this.getPublicSelectData()
  },
  methods: {
    // 点击每个国家时触发的回调
    handleCountryItem(country) {
      if (this.active === country.code) return
      this.$emit('click', country)
    },
    // 获取语言列表
    async getPublicSelectData() {
      try {
        let { data } = await API.getPublicSelectData({ type: 1, param: undefined })
        this.countrys = data
        this.$emit('codeChange', this.countrys[0])
      } catch (error) {
        throw new Error(error.message)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.country-item {
  display: block;
  height: 62px;
  line-height: 68px;
  text-align: center;
  padding: 0 5px;
  cursor: pointer;
  user-select: none;
  border-bottom: 3px solid #797979;
  transition: border-bottom 0.3s;
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.active {
  transition: all 0.3s;
  border-bottom: 3px solid #99c41c !important;
}
</style>